import React from 'react';
import TabsComponent from './Tabs';
import { TabProvider, useTab } from './Tabs.Context';
import type { TabsProps } from './Tabs.types';

export type { TabsProps };
export { useTab };

// Wrap the Tabs component with the TabProvider
const Tabs = (props: TabsProps) => {
  const {
    value,
    style,
    onClick,
    ...restProps
  } = props;
  return (
    <TabProvider value={value} style={style} onClick={onClick} >
      <TabsComponent {...restProps} style={style}/>
    </TabProvider>
  );
};
export default Tabs;
